"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationOpportunityViewedByFacilityAdminSource = void 0;
exports.instanceOfOrientationOpportunityViewedByFacilityAdminSource = instanceOfOrientationOpportunityViewedByFacilityAdminSource;
exports.OrientationOpportunityViewedByFacilityAdminSourceFromJSON = OrientationOpportunityViewedByFacilityAdminSourceFromJSON;
exports.OrientationOpportunityViewedByFacilityAdminSourceFromJSONTyped = OrientationOpportunityViewedByFacilityAdminSourceFromJSONTyped;
exports.OrientationOpportunityViewedByFacilityAdminSourceToJSON = OrientationOpportunityViewedByFacilityAdminSourceToJSON;
exports.OrientationOpportunityViewedByFacilityAdminSourceToJSONTyped = OrientationOpportunityViewedByFacilityAdminSourceToJSONTyped;
/**
 *
 * @export
 */
exports.OrientationOpportunityViewedByFacilityAdminSource = {
    DetailsPage: 'details_page'
};
function instanceOfOrientationOpportunityViewedByFacilityAdminSource(value) {
    for (const key in exports.OrientationOpportunityViewedByFacilityAdminSource) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationOpportunityViewedByFacilityAdminSource, key)) {
            if (exports.OrientationOpportunityViewedByFacilityAdminSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationOpportunityViewedByFacilityAdminSourceFromJSON(json) {
    return OrientationOpportunityViewedByFacilityAdminSourceFromJSONTyped(json, false);
}
function OrientationOpportunityViewedByFacilityAdminSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationOpportunityViewedByFacilityAdminSourceToJSON(value) {
    return value;
}
function OrientationOpportunityViewedByFacilityAdminSourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationOpportunityViewedByFacilityAdminSource.js.map